import * as _ from 'lodash';
import {Injectable} from "@angular/core";

@Injectable()
export class ValueClassProvider {
    valueClasses = [
        {code: 1, label: 'Receitas'},
        {code: 2, label: 'Operacionais'},
        {code: 3, label: 'Não-Operacionais'},
        {code: 4, label: 'Custos Diretos'},
        {code: 5, label: 'M.D.O'},
        {code: 6, label: 'Variáveis'},
        {code: 7, label: 'Estruturas'},
        {code: 8, label: 'Outros'},
        {code: 9, label: 'Custos Indiretos'},
        {code: 10, label: 'Administrativo'},
        {code: 11, label: 'Comercial'},
        {code: 12, label: 'Financeiro'},
        {code: 13, label: 'Infraestrutura'},
        {code: 14, label: 'R&S'},
        {code: 15, label: 'Marketing'},
        {code: 16, label: 'Investimentos'},
    ]

    find(valueClassCode) {
        const valueClass = this.valueClasses.filter(valueClass => valueClass.code == valueClassCode);

        if (_.isEmpty(valueClass))
            throw 'Classe de valor inválida';

        return valueClass;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/enums/value-class.provider.ts